/**
 * CTA Cursor Magnetic — pointer-driven 8px translate toward the cursor.
 *
 * Bind to any element marked [data-cta-magnetic]. On pointermove the element
 * shifts toward the pointer by up to 8px (configurable via data-cta-magnet-max).
 * Resets to (0,0) on pointerleave.
 *
 * Skips touch/pen pointers — magnetism is a fine-pointer effect.
 */

const SELECTOR = "[data-cta-magnetic]";
const DEFAULT_MAX = 8;

function attach(el) {
  if (el.dataset.ctaMagneticBound === "1") return;
  el.dataset.ctaMagneticBound = "1";

  const max = Number(el.dataset.ctaMagnetMax) || DEFAULT_MAX;
  let rafId = 0;
  let dx = 0;
  let dy = 0;

  function commit() {
    el.style.setProperty("--mag-cta-x", `${dx.toFixed(2)}px`);
    el.style.setProperty("--mag-cta-y", `${dy.toFixed(2)}px`);
    rafId = 0;
  }

  function schedule(x, y) {
    dx = x;
    dy = y;
    if (!rafId) rafId = requestAnimationFrame(commit);
  }

  el.addEventListener("pointermove", (e) => {
    if (e.pointerType !== "mouse") return;
    const rect = el.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const nx = (e.clientX - cx) / (rect.width / 2);
    const ny = (e.clientY - cy) / (rect.height / 2);
    schedule(
      Math.max(-1, Math.min(1, nx)) * max,
      Math.max(-1, Math.min(1, ny)) * max,
    );
  });

  el.addEventListener("pointerleave", () => schedule(0, 0));
  el.addEventListener("touchstart", () => schedule(0, 0), { passive: true });
}

function init() {
  document.querySelectorAll(SELECTOR).forEach(attach);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}

document.addEventListener("shopify:section:load", init);
